import { useEffect, useRef, useState } from "react";
import { getAnimations } from "../../../services/animation.service";
import LoadTrigger from "../../../components/common/LoadTrigger";
import PageHeader from "../../../components/common/PageHeader";
import { useNavigate } from "react-router-dom";
import VisualizationGrid from "../../../components/visualizations/VisualizationGrid";
import Controls from "../../../components/visualizations/Controls";
import AnimationCard from "../../../components/studio/AnimationCard";

const Animations = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const pageRef = useRef(1);
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [search, setSearch] = useState("desc");
  const navigate = useNavigate();
  const reqIdRef = useRef(1);
  const syncIsLoadingRef = useRef(false);
  const sortOptions = {
    Title: "title",
    CreatedAt: "createdAt",
    UpdatedAt: "updatedAt",
  };

  const onLoadMore = async (reset = false) => {
    if (!reset && (syncIsLoadingRef.current || !hasMore)) return;

    setIsLoading(true);
    syncIsLoadingRef.current = true;
    try {
      const query = {
        page: reset ? 1 : pageRef.current,
        sortBy,
        sortOrder,
        ...(search ? { search } : {}),
      };
      if (reset) {
        pageRef.current = 2;
        ++reqIdRef.current;
        setHasMore(true);
      } else {
        pageRef.current++;
      }
      const reqId = reqIdRef.current;

      const visualizationsData = await getAnimations(query);
      if (reqId !== reqIdRef.current) {
        return;
      }
      setHasMore(visualizationsData.page < visualizationsData.totalPages);
      setRecords((prev) =>
        reset
          ? visualizationsData.records
          : [...prev, ...visualizationsData.records],
      );
    } catch (error) {
      --pageRef.current;
    } finally {
      setIsLoading(false);
      syncIsLoadingRef.current = false;
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(async () => await onLoadMore(true), 500);
    return () => clearTimeout(timeoutId);
  }, [search, sortBy, sortOrder]);

  return (
    <>
      <PageHeader
        title={"Animations"}
        description={
          "Transform complex theory into beautiful, interactive animations."
        }
        action={
          <button
            className="primary-btn"
            onClick={() => navigate("/studio/animations/new")}
          >
            + New Animation
          </button>
        }
      />
      <Controls
        setDebouncedSearch={setSearch}
        sortBy={sortBy}
        setSortBy={setSortBy}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        sortOptions={sortOptions}
      />
      <VisualizationGrid
        records={records}
        isLoading={isLoading}
        isStudio={true}
        Card={AnimationCard}
        onDelete={(id) => setRecords((prev) => prev.filter((r) => r.animationId !== id))}
      />

      <LoadTrigger
        onLoadMore={onLoadMore}
        hasMore={hasMore}
        isLoading={isLoading}
      />
    </>
  );
};

export default Animations;
